import { render, staticRenderFns } from "./ViewEntityPermissionsByUser.vue?vue&type=template&id=4d40c9b2&scoped=true"
import script from "./ViewEntityPermissionsByUser.vue?vue&type=script&lang=js"
export * from "./ViewEntityPermissionsByUser.vue?vue&type=script&lang=js"
import style0 from "./ViewEntityPermissionsByUser.vue?vue&type=style&index=0&id=4d40c9b2&prod&lang=scss"
import style1 from "./ViewEntityPermissionsByUser.vue?vue&type=style&index=1&id=4d40c9b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40c9b2",
  null
  
)

export default component.exports